export default __webpack_public_path__ + "static/media/img-signup-welcome-group.8bd007c9.svg";